import { EVENT_CATEGORIES, EVENTS } from "../../constants/events";
import { useAnalytics } from "../../contexts/segment";

export const useActionsTrack = () => {
  const { track } = useAnalytics();

  // O contexto do Segment tem default `{}`, então fora do AnalyticsProvider `track` é
  // undefined. Telemetria nunca deve derrubar a ação do usuário (o clique no botão
  // acontece antes do efeito), então tratamos a ausência como no-op.
  const safeTrack: typeof track = (eventName, data) => {
    if (typeof track !== "function") return;
    return track(eventName, data);
  };

  const onActionClick = (
    event: keyof typeof EVENTS,
    category: keyof typeof EVENT_CATEGORIES,
    data?: object,
  ) => {
    if (data) {
      return safeTrack(EVENTS[event], {
        category: EVENT_CATEGORIES[category],
        value: { ...data },
      });
    }
    return safeTrack(EVENTS[event], {
      category: EVENT_CATEGORIES[category],
    });
  };

  const onActionView = (event: keyof typeof EVENTS) => {
    safeTrack(EVENTS[event], { category: EVENT_CATEGORIES.VIEW });
  };

  return { onActionClick, onActionView };
};
